export default __webpack_public_path__ + "static/media/company-min.2a204552.jpg";